import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  DialogContentText,
} from '@mui/material';
import UserForm from './UserForm';

const AddMemberButton = ({ addMemberToTeam }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (payload) => {
    // Call the function to add the member to the selected team
    addMemberToTeam(payload);
    handleClose();
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        Add New Member
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add New Member</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please fill in the following fields to add a new member.
          </DialogContentText>
          <UserForm onCancel={handleClose} onSubmit={handleSubmit} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AddMemberButton;
